export default "__VITE_ASSET__DquSrMa6__"